'use strict';

module.exports = () => {
    return {
        // Hub & Thrust Admin
        "Job Posting(if date not known, quote the Job ID number)": ["Hub Admin", "Thrust Admin", "System Admin"],
        "Information/materials provided by the Candidate": ["Hub Admin", "Thrust Admin", "System Admin"],
        "Full CV": ["Hub Admin", "Thrust Admin", "System Admin"],
        "Cover letter": ["Hub Admin", "Thrust Admin", "System Admin"],
        "Research statement": ["Hub Admin", "Thrust Admin", "System Admin"],
        "Teaching statement": ["Hub Admin", "Thrust Admin", "System Admin"],
        "Most representative publication": ["Hub Admin", "Thrust Admin", "System Admin"],
        "Second most representative publication": ["Hub Admin", "Thrust Admin", "System Admin"],
        "Third most representative publication": ["Hub Admin", "Thrust Admin", "System Admin"],
        "Fourth most representative publication": ["Hub Admin", "Thrust Admin", "System Admin"],
        "Fifth most representative publication": ["Hub Admin", "Thrust Admin", "System Admin"],
        "Record of teaching performance (if any)": ["Hub Admin", "Thrust Admin", "System Admin"],
        "Names and contact information of DEPENDENT referees": ["Hub Admin", "Thrust Admin", "System Admin"],
        "DEPENDENT Letter #": ["Hub Admin", "Thrust Admin", "System Admin"],
        "Sample soliciting letter or email (DEPENDENT)": ["Hub Admin", "Thrust Admin", "System Admin"],
        "Names and contact information of INDEPENDENT referees": ["Hub Admin", "Thrust Admin", "System Admin"],
        "INDEPENDENT reference report and INDEPENDENT referees' CVs": ["Hub Admin", "Thrust Admin", "System Admin"],
        "INDEPENDENT Letter #": ["Hub Admin", "Thrust Admin", "System Admin"],
        "Sample soliciting letter or email (INDEPENDENT)": ["Hub Admin", "Thrust Admin", "System Admin"],
        "References (External letters in the last review dossier in CWB) (if any)": ["Hub Admin", "Thrust Admin", "System Admin"],
        "A list of Top Journals/ Conferences in candidate's research area": ["Hub Admin", "Thrust Admin", "System Admin"],
        "Presentation Talk (video)": ["Hub Admin", "Thrust Admin", "System Admin"],
        "Technical Open Seminar": ["Hub Admin", "Thrust Admin", "System Admin"],
        "Interview": ["Hub Admin", "Thrust Admin", "System Admin"],
        "Domain Expert Committee (DEC) Recommendation Report (if any)": ["Hub Admin", "Thrust Admin", "System Admin"],
        "DEC membership list (if any)": ["Hub Admin", "Thrust Admin", "System Admin"],
        "Thrust Search and Substantiation Committee (Thrust SSC) Recommendation Report": ["Hub Admin", "Thrust Admin", "System Admin"],
        "Thrust SSC membership list": ["Hub Admin", "Thrust Admin", "System Admin"],
        "Acting Thrust Head's additional justification (if any)": ["Hub Admin", "Thrust Admin", "System Admin"],
        // Hub Admin Only
        "Hub Dean Recommendation": ["Hub Admin", "System Admin"],

        // ARB Only
        "ARB's Review Outcome (if applicable)": ["ARB Secretariat", "System Admin"],
        "ARB's Report to UASC (if applicable)": ["ARB Secretariat", "System Admin"],

        // UASC Only
        "UASC's Review Outcome (if applicable)": ["UASC Secretariat", "System Admin"],

        // Useless
        // "Proposed Package": ["Hub Admin", "System Admin"],
        // "Honorary unpaid title , (if applicable)": ["Hub Admin", "System Admin"],
        // "Start-up Agreement signed by Thrust Head, Hub Dean & Provost": ["Hub Admin", "System Admin"],
        // "Covering Letter of Appointment": ["Hub Admin", "System Admin"],
        // "Employment Contract": ["Hub Admin"]
    }
}
